import React, { useState } from "react";
import withJuspay from "@hooks/withJuspay";

const PlaceOrderHOC = (PlaceOrder) => {
  return function Wrapper(props) {
    const [initiateResult, setInitiateResult] = useState(() => () => {});
    const [processResult, setProcessResult] = useState(() => () => {});

    const { processPayment } = withJuspay({
      initiateResult,
      processResult,
    });

    return (
      <PlaceOrder
        {...props}
        processPayment={processPayment}
        setInitiateResult={setInitiateResult}
        setProcessResult={setProcessResult}
      />
    );
  };
};

export default PlaceOrderHOC;
